<template>
  <standard-dialog
    v-model="model"
    :title="formTitle"
    :max-width="1000"
    icon="mdi-store"
    @save="save"
    :disabled="!valid"
    :loading="saving"
  >
    <v-container>
      <v-form v-model="valid">
        <v-row>
          <v-col cols="12">
            <v-row no-gutters align="center" justify="space-between">
              <div>
                <span class="caption font-weight-medium">{{ $t("type") }}</span>
                <v-radio-group row v-model="editedItem.entity_type">
                  <v-radio :label="$t('restaurant')" value="restaurant"></v-radio>
                  <v-radio :label="$t('shop')" value="shop"></v-radio>
                  <v-radio :label="$t('post')" value="delivery"></v-radio>
                </v-radio-group>
              </div>

              <primary-button
                v-if="editedItem?.settings?.lice_bez_ugovora"
                small
                :dark="!loadingQr"
                class="mr-4"
                @click="generateQRCode"
                :loading="loadingQr"
              >
                <v-icon class="mr-2">mdi-checkerboard</v-icon>
                <span>{{ $t("qr") }}</span>
              </primary-button>
            </v-row>
            <v-switch
              @click="switchStatus"
              v-model="editedItem.state"
              inset
              :label="$t('status')"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <text-field
              v-model="editedItem.name"
              :label="$t('title')"
              required
              :rules="[rules.required]"
            ></text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <autocomplete
              v-model="editedItem.parent"
              :items="userRestorans.filter((item) => item.id)"
              :label="$t('parent_restaurant')"
              item-text="name"
              item-id="id"
              return-object
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field
              v-model="editedItem.email"
              :label="$t('email')"
              required
              :rules="[rules.required]"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field
              v-model="editedItem.phone"
              :label="$t('phone')"
              required
              :rules="[rules.required]"
            />
          </v-col>

          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <autocomplete
              @change="updateAvailableCities"
              v-model="editedItem.country"
              :items="availableCountries"
              :label="$t('country')"
              required
              :rules="[rules.required]"
              item-text="name"
              item-id="id"
              return-object
              :loading="loadingCountries"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <autocomplete
              v-model="editedItem.city"
              :items="availableCities"
              :label="$t('city')"
              required
              :rules="[rules.required]"
              item-text="name"
              item-id="id"
              return-object
              :loading="loadingCountries"
            />
          </v-col>

          <v-col cols="12" md="6" lg="4">
            <text-field
              v-model="editedItem.address"
              :label="$t('address')"
              required
              :rules="[rules.required]"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field v-model="editedItem.latitude" :label="$t('lati1')" />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field v-model="editedItem.longitude" :label="$t('long1')" />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field
              v-model="editedItem.delivery_distance"
              type="number"
              :label="$t('delivery_distance')"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field v-model="editedItem.lib" :label="$t('jib')" />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field v-model="editedItem.pib" :label="$t('pib')" />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field v-model="editedItem.owner" :label="$t('owner')" />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field
              v-model="editedItem.contact_person"
              :label="$t('contact_person')"
            />
          </v-col>
          <v-col cols="12" class="mb-4 pb-0">
            <h4>{{ $t("pay_type") }}</h4>
            <v-radio-group row v-model="editedItem.restoran_tip_ugovora.paying_type">
              <v-radio :label="$t('by_month')" :value="1"></v-radio>
              <v-radio :label="$t('by_percent')" :value="2"></v-radio>
              <v-radio :label="$t('by_meal')" :value="3"></v-radio>
            </v-radio-group>
            <text-field
              v-if="editedItem.restoran_tip_ugovora.paying_type"
              type="number"
              v-model="editedItem.restoran_tip_ugovora.amount"
              :label="
                $t('amount') +
                ' ' +
                (editedItem.restoran_tip_ugovora.paying_type == 2
                  ? '%'
                  : $store.state.restaurant.settings.price
                  ? $store.state.restaurant.settings.price
                  : '')
              "
            />
          </v-col>

          <v-row no-gutters v-if="user.type === 'admin'">
            <v-col cols="auto">
              <v-switch
                inset
                label="Ankete"
                hide-details
                class="mt-3 pr-4"
                v-model="hasQuestionnaires"
                @change="toggleQuestionnaire"
              />
            </v-col>
            <v-col>
              <v-row>
                <template v-for="(questionnaire, i) in questionnaires">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="3">
                        <text-field
                          label="ID Ankete"
                          v-model="questionnaire.qid"
                          dense
                          :disabled="!hasQuestionnaires"
                          hide-details
                        />
                      </v-col>
                      <v-col cols="7">
                        <autocomplete
                          v-model="questionnaire.roles"
                          :label="$t('role')"
                          :items="['admin', 'guest', 'customer']"
                          :disabled="!hasQuestionnaires"
                          multiple
                          small-chips
                          deletable-chips
                          dense
                          hide-details
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-row
                          v-if="i === questionnaires.length - 1"
                          no-gutters
                          justify="center"
                          align="center"
                          class="fill-height"
                        >
                          <circle-button
                            icon="mdi-minus"
                            :disabled="!hasQuestionnaires"
                            color="primary"
                            @click="questionnaires.splice(i, 1)"
                          />
                          <circle-button
                            icon="mdi-plus"
                            :disabled="!hasQuestionnaires"
                            color="primary"
                            @click="
                              questionnaires.push({
                                qid: null,
                                roles: [],
                              })
                            "
                          />
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </v-row>
      </v-form>
    </v-container>

    <qr-code-dialog v-model="qrDialog" :qr-secret="qrSecret" />
  </standard-dialog>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import QrCodeDialog from "./QrCodeDialog.vue";
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import restaurantService from "@/services/restaurant";

export default {
  name: "RestaurantEditDialog",
  mixins: [hasModel, hasValidation, hasSnackbar],
  components: {
    StandardDialog,
    QrCodeDialog,
  },
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    userRestorans: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      questionnaires: [],
      hasQuestionnaires: false,
      qrDialog: false,
      qrSecret: "",
      loadingQr: false,
      availableCountries: [],
      availableCities: [],
      loadingCountries: false,
    };
  },
  watch: {
    model(val) {
      if (val) {
        this.fetchCountries();
        this.fetchQuestionnaires();
      }
    },
    "editedItem.country": {
      handler() {
        this.updateAvailableCities();
      },
      deep: true,
    },
  },
  methods: {
    async fetchQuestionnaires() {
      this.questionnaires = [];
      this.hasQuestionnaires = false;
      if (!this.editedItem.id || this.user.type !== "admin") {
        return;
      }
      try {
        const { data } = await restaurantService.getRestaurantQuestionnaires(
          this.editedItem.id
        );
        if (data && data.length > 0) {
          this.questionnaires = data;
          this.hasQuestionnaires = true;
        }
      } catch (error) {
        this.showErrorSnackbar(
          error,
          this.$t("error_loading_questionnaires") || "Error loading questionnaires"
        );
      }
    },
    async fetchCountries() {
      if (this.availableCountries.length > 0) {
        this.matchCountryAndCity();
        this.updateAvailableCities();
        return;
      }
      this.loadingCountries = true;
      try {
        const { data } = await restaurantService.getCountriesAll();
        this.availableCountries = data.map((country) => ({
          ...country,
          name: this.toLatin(country.name),
          cities: (country.cities || []).map((city) => ({
            ...city,
            name: this.toLatin(city.name),
          })),
        }));
        this.matchCountryAndCity();
        this.updateAvailableCities();
      } catch (error) {
        this.showErrorSnackbar(error, this.$t("error_loading_countries"));
      } finally {
        this.loadingCountries = false;
      }
    },
    matchCountryAndCity() {
      let targetCityId = this.editedItem.city_id;
      if (!targetCityId && this.editedItem.city && this.editedItem.city.id) {
        targetCityId = this.editedItem.city.id;
      }

      if (targetCityId) {
        for (const country of this.availableCountries) {
          const city = (country.cities || []).find((c) => c.id === targetCityId);
          if (city) {
            this.$set(this.editedItem, "country", country);
            this.$set(this.editedItem, "city", city);
            break;
          }
        }
      }
    },
    updateAvailableCities() {
      if (!this.editedItem.country) {
        this.availableCities = [];
        return;
      }

      if (this.editedItem.country.cities) {
        this.availableCities = this.editedItem.country.cities || [];
      } else {
        const countryId = this.editedItem.country.id;
        this.availableCities = this.availableCountries
          .flatMap((country) => country.cities)
          .filter((city) => city.country_id === countryId);
      }
    },
    toggleQuestionnaire() {
      if (this.hasQuestionnaires && this.questionnaires.length === 0) {
        this.questionnaires.push({ qid: null, roles: [] });
      } else if (!this.hasQuestionnaires) {
        this.questionnaires = [];
      }
    },
    switchStatus() {
      restaurantService.changeRestaurantStatus(this.editedItem);
    },
    generateQRCode() {
      this.loadingQr = true;
      restaurantService
        .generateRestaurantCode(this.editedItem)
        .then(({ data }) => {
          this.qrSecret = data;
          this.qrDialog = true;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_generating_qr_code"));
        })
        .finally(() => {
          this.loadingQr = false;
        });
    },
    save() {
      const pureQ = this.questionnaires.filter((q) => q.qid);
      this.$emit("save", this.hasQuestionnaires ? pureQ : []);
    },
  },
  computed: {
    formTitle() {
      return !this.editedItem.id
        ? this.$t("new_restaurant")
        : this.$t("restaurant") + ": " + this.editedItem.id;
    },
    user() {
      return this.$store.state.user.user;
    },
  },
};
</script>
